export default __webpack_public_path__ + "static/media/contact-nomi-mobile.b02ad748.svg";